let moment = require('moment');


export let colApCompensationStructure = {colId: 'apCompensationStructure',
                                            headerName: 'Compensation Structure',
                                            field: 'apCompensationStructure',
                                            width: 50,
                                            sortable: true };

export let colAcFinancialComp = {   colId: 'acuteCareComp',
                                    headerName: 'Comp Max/Fixed',
                                    field: 'acuteCareComp',
                                    width: 100,
                                    type: 'number',
                                    sortable: true};

export let colApSignOnBonusAmount = {colId: 'apSignOnBonusAmount',
                                            headerName: 'Sign On Bonus Amount',
                                            field: 'apSignOnBonusAmount',
                                            width: 50,
                                            type: 'number',
                                            sortable: true };
export let colApRetentionBonus = {colId: 'apRetentionBonus',
                                            headerName: 'Retention Bonus',
                                            field: 'apRetentionBonus',
                                            width: 50,
                                            type: 'number',
                                            sortable: true };
export let colApRetentionBonusPeriod = {colId: 'apRetentionBonusPeriod',
                                            headerName: 'Retention Bonus Period',
                                            field: 'apRetentionBonusPeriod',
                                            width: 50,
                                            type: 'number',
                                            sortable: true };

export let colwRVUs = {colId: 'apWRVU',
                                            headerName: 'work RVU',
                                            field: 'apWRVU',
                                            width: 50,
                                            type: 'number',
                                            sortable: true };

export let colSalary = {colId: 'apSalary',
                                            headerName: 'Salary',
                                            field: 'apSalary',
                                            width: 50,
                                            type: 'number',
                                            sortable: true };

export let colAcFinancialHourlyRate = { colId: 'acuteCareHourlyRate',
                                        headerName: 'Hourly Rate',
                                        field: 'acuteCareHourlyRate',
                                        width: 100,
                                        type: 'number',
                                        sortable: true};

export let colTeachingCompensation = { colId: 'apTeachingCompensation',
                                        headerName: 'Teaching Compensation',
                                        field: 'apTeachingCompensation',
                                        width: 100,
                                        type: 'number',
                                        sortable: true};

export let colApMedicalDirectorFee = {colId: 'apMedicalDirectorFee',
                                            headerName: 'Medical Director Fee',
                                            field: 'apMedicalDirectorFee',
                                            width: 50,
                                            type: 'number',
                                            sortable: true };

export let colApCmoFee = {colId: 'apCmoFee',
                                            headerName: 'CMO Fee',
                                            field: 'apCmoFee',
                                            width: 50,
                                            type: 'number',
                                            sortable: true };

export let colApDateChangeFromGuaranteeToProd = {
                                                    colId: 'apDateChangeFromGuaranteeToProd',
                                                    headerName: 'Date Change From Guarantee To Prod',
                                                    field: 'apDateChangeFromGuaranteeToProd',
                                                    width: 50,
                                                    sortable: true,
                                                    cellRenderer: dateFormatter
                                                };

export let colApDateRetentionBonusPaid = {
                                            colId: 'apDateRetentionBonusPaid',
                                            headerName: 'AP - Date Retention Bonus Paid',
                                            field: 'apDateRetentionBonusPaid',
                                            width: 50,
                                            type: 'number',
                                            sortable: true,
                                            cellRenderer: dateFormatter
                                        };


export let colApGuaranteedPayAmount = {colId: 'apGuaranteedPayAmount',
                                            headerName: 'Guaranteed Pay Amount',
                                            field: 'apGuaranteedPayAmount',
                                            width: 50,
                                            type: 'number',
                                            sortable: true };


export let colApBonusPaybackPeriod = {colId: 'apBonusPaybackPeriod',
                                            headerName: 'Bonus Payback Period',
                                            field: 'apBonusPaybackPeriod',
                                            width: 50,
                                            type: 'number',
                                            sortable: true };

export let colApRelocationAmount = {colId: 'apRelocationAmount',
                                            headerName: 'Relocation Amount',
                                            field: 'apRelocationAmount',
                                            width: 50,
                                            type: 'number',
                                            sortable: true };

export let colAcFinancialRangeFMV = {   colId: 'acuteCareRangeFMV',
                                        headerName: 'Range of FMV',
                                        field: 'acuteCareRangeFMV',
                                        width: 100,
                                        sortable: true};

export let colhrCmeDues = {   colId: 'hrCmeDues',
                                        headerName: 'CME Dues',
                                        field: 'hrCmeDues',
                                        width: 50,
                                        type: 'number',
                                        sortable: true};

export let colvaluePerDiem = {   colId: 'valuePerDiem',
                                        headerName: 'Per Diem',
                                        field: 'valuePerDiem',
                                        width: 50,
                                        type: 'number',
                                        sortable: true};

export let colPtoTimeOff = {   colId: 'hrPtoTimeOff',
                                        headerName: 'PTO/Time Off',
                                        field: 'hrPtoTimeOff',
                                        width: 50,
                                        sortable: true};

export let colAcFinancialSpecialty = {  colId: 'acuteCareSpecialty',
                                        headerName: 'Specialty',
                                        field: 'acuteCareSpecialty',
                                        width: 100,
                                        sortable: true};

export let colAcKeyTerms = {  colId: 'acuteCareKeyTerms',
                                        headerName: 'Key Terms',
                                        field: 'acuteCareKeyTerms',
                                        width: 100,
                                        sortable: true};

export let colHrGroup = {  colId: 'hrGroup',
                                        headerName: 'Group',
                                        field: 'hrGroup',
                                        width: 50,
                                        sortable: true};

export let colHrProduct = {  colId: 'hrProduct',
                                        headerName: 'Product',
                                        field: 'hrProduct',
                                        width: 50,
                                        sortable: true};

export let colHrLawsonNumber = {  colId: 'hrLawsonNumber',
                                        headerName: 'Lawson Number',
                                        field: 'hrLawsonNumber',
                                        width: 50,
                                        sortable: true};

export let colAcSquareFootage = {  colId: 'acuteCareSquareFootage',
                                        headerName: 'Square Footage',
                                        field: 'acuteCareSquareFootage',
                                        width: 100,
                                        type: 'number',
                                        sortable: true};

export let colHrDnv = {  colId: 'hrDnv',
                                        headerName: 'DNV Critical or Non-Critical',
                                        field: 'hrDnv',
                                        width: 100,
                                        sortable: true};

export let colHrOtherInfo = {  colId: 'hrOtherInfo',
                                        headerName: 'Other Info',
                                        field: 'hrOtherInfo',
                                        width: 100,
                                        sortable: true};



export let allColumns = [
    colApCompensationStructure,
    colAcFinancialComp,
    colApSignOnBonusAmount,
    colApRetentionBonus,
    colApRetentionBonusPeriod,
    colwRVUs,
    colSalary,
    colAcFinancialHourlyRate,
    colTeachingCompensation,
    colApMedicalDirectorFee,
    colApCmoFee,
    colApDateChangeFromGuaranteeToProd,
    colApDateRetentionBonusPaid,
    colApGuaranteedPayAmount,
    colApBonusPaybackPeriod,
    colApRelocationAmount,
    colAcFinancialRangeFMV,
    colhrCmeDues,
    colvaluePerDiem,
    colPtoTimeOff,
    colAcFinancialSpecialty,
    colAcKeyTerms,
    colHrGroup,
    colHrProduct,
    colHrLawsonNumber,
    colAcSquareFootage,
    colHrDnv,
    colHrOtherInfo
];



export let columnSelectList = [
    {
        value: colAcFinancialComp,
        viewValue: colAcFinancialComp.headerName
    },
    {
        value: colAcFinancialHourlyRate,
        viewValue: colAcFinancialHourlyRate.headerName
    },
    {
        value: colAcFinancialRangeFMV,
        viewValue: colAcFinancialRangeFMV.headerName
    },
    {
        value: colAcFinancialSpecialty,
        viewValue: colAcFinancialSpecialty.headerName
    },
    {
        value: colAcKeyTerms,
        viewValue: colAcKeyTerms.headerName
    },
    {
        value: colAcSquareFootage,
        viewValue: colAcSquareFootage.headerName
    },
    {
        value: colApCompensationStructure,
        viewValue: colApCompensationStructure.headerName
    },
    {
        value: colApSignOnBonusAmount,
        viewValue: colApSignOnBonusAmount.headerName
    },
    {
        value: colApRetentionBonus,
        viewValue: colApRetentionBonus.headerName
    },
    {
        value: colApRetentionBonusPeriod,
        viewValue: colApRetentionBonusPeriod.headerName
    },
    {
        value: colwRVUs,
        viewValue: colwRVUs.headerName
    },
    {
        value: colSalary,
        viewValue: colSalary.headerName
    },
    {
        value: colTeachingCompensation,
        viewValue: colTeachingCompensation.headerName
    },
    {
        value: colApMedicalDirectorFee,
        viewValue: colApMedicalDirectorFee.headerName
    },
    {
        value: colApCmoFee,
        viewValue: colApCmoFee.headerName
    },
    {
        value: colApDateChangeFromGuaranteeToProd,
        viewValue: colApDateChangeFromGuaranteeToProd.headerName
    },
    {
        value: colApDateRetentionBonusPaid,
        viewValue: colApDateRetentionBonusPaid.headerName
    },
    {
        value: colApGuaranteedPayAmount,
        viewValue: colApGuaranteedPayAmount.headerName
    },
    {
        value: colApBonusPaybackPeriod,
        viewValue: colApBonusPaybackPeriod.headerName
    },
    {
        value: colApRelocationAmount,
        viewValue: colApRelocationAmount.headerName
    },
    {
        value: colhrCmeDues,
        viewValue: colhrCmeDues.headerName
    },
    {
        value: colvaluePerDiem,
        viewValue: colvaluePerDiem.headerName
    },
    {
        value: colPtoTimeOff,
        viewValue: colPtoTimeOff.headerName
    },
    {
        value: colHrGroup,
        viewValue: colHrGroup.headerName
    },
    {
        value: colHrProduct,
        viewValue: colHrProduct.headerName
    },
    {
        value: colHrLawsonNumber,
        viewValue: colHrLawsonNumber.headerName
    },
    {
        value: colHrDnv,
        viewValue: colHrDnv.headerName
    },
    {
        value: colHrOtherInfo,
        viewValue: colHrOtherInfo.headerName
    },
];




function  dateFormatter(params) {

    if (params.value == undefined) {
        return null;
    } else {
        let dateObject = moment(params.value);
        let friendlyDate = dateObject.format('ll');

        if (friendlyDate == 'Invalid date') {
            // console.log('invalid date: ', params.value);
            return params.value;
        } else {
            // console.log('valid date: ', friendlyDate);
            return friendlyDate;
        }
    }
}




function currencyFormatter(params) {

    let usdFormate = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0
    });

    if (usdFormate.format(params.value) == '$0' ||
        (usdFormate.format(params.value) == '$NaN')) {
      return '$0.00';
    } else {
      return usdFormate.format(params.value);
    }

  }
